// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"ffec457b","537":"53abcb65","643":"53abcb65","728":"0abf5c43","946":"5834e18f"}[chunkId] + ".chunk.css";
};